import Grid from '@material-ui/core/Grid'
import Select from 'Components/Select'
import Title from 'Components/Title'
import Upload from 'Components/Upload'
import React from 'react'


export default React.memo(props => <Title inline={props.inline} style={{ padding: '5px 0' }} title={props.title}
                                          buttons={(props.comboMultipleOption(props.options)).length > 0 && !props.disabled &&
                                          <button type="button" onClick={props.onClickAddComboMultiEntier}
                                                  className="text-success ei-commun_ajouter"
                                                  style={{ display: 'inline-block', marginLeft: 5 }}/>}>
  {
    (props.data !== undefined ? props.data : []).map((data, index) => (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
            alignItems={'center'}>
        {!props.disabled && <Grid item style={{ margin: 0, padding: 0 }}>
          <button type="button" onClick={() => props.onClickRemoveComboMultiEntier(index)}
                  className="text-danger ei-commun_enlever"
                  disabled={props.disabled || false}/>
        </Grid>}
        <Grid item xs style={{ margin: 0, padding: 0 }}>
          <Select style={props.style}
                  disabled={props.disabled || false}
                  options={props.comboMultipleOption(props.options, data.id)}
                  onChange={props.onChangeComboMultiEntier}
                  name={index}
                  value={data.id}/>
        </Grid>
        {props.client_id && (!props.disabled || (props.disabled && data.valeur_entier)) &&
        <Grid item style={{ margin: 0, padding: 0 }}>
          <Upload disabled={props.disabled || false} media_id={data.valeur_entier} link={data.lien}
                  client_id={props.client_id}
                  onChange={(r) => props.onChangeInputComboMultiUpload(r.id, index, r.lien)}/>
        </Grid>}
      </Grid>
    ))
  }
</Title>)



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboMultipleDocument.js